import tinycolor from "tinycolor2"
import { Gradient, GradientError } from "./Gradient"

const COLOR = 0
const POSITION = 1

class RadialGradient extends Gradient {
  #type = "radial"
  // #angle = null
  #siteX = 0
  #siteY = 0

  constructor({ siteY = 0, siteX = 0, stops = undefined, limit = undefined } = {}) {
    super({ stops, limit })
    this.#type = "radial"
    // this.#angle = angle
    this.#siteX = siteX
    this.#siteY = siteY
  }
  set siteX(value) {
    this.#siteX = value
  }
  get siteX() {
    return parseInt(this.#siteX)
  }

  set siteY(value) {
    this.#siteY = value
  }
  get siteY() {
    return parseInt(this.#siteY)
  }
  get type() {
    return this.#type
  }
  get getJson() {
    return {
      type: this.#type,
      siteX: this.#siteX,
      siteY: this.#siteY,
      stops: this.stops,
      limit: this.limit
    }
  }
  toString(colorFormat = "hex8") {
    const stops = this.stops
      .slice()
      .sort((a, b) => a[POSITION] - b[POSITION])
      .map(stop => `${tinycolor(stop[COLOR]).toString(colorFormat)} ${(stop[POSITION] * 100).toFixed()}%`)
      .join(", ")
    return `linear-gradient(${this.angle}deg, ${stops})`
  }

  toRaw(colorFormat = "hex8") {
    const stops = this.stops
      .slice()
      .sort((a, b) => a[POSITION] - b[POSITION])
      .map(stop => {
        stop[COLOR] = tinycolor(stop[COLOR]).toString(colorFormat)
        return stop
      })
    return {
      type: this.type,
      siteX: this.siteX,
      siteY: this.siteY,
      stops,
      limit: this.limit
    }
  }
}

export default RadialGradient
